const STORAGE_KEY = "ocp.mock.db.v8";
const SCHEMA_VERSION = 8;

export interface PersistedState<T> {
  version: number;
  data: T;
}

function resetRequested() {
  const url = new URL(window.location.href);
  if (url.searchParams.get("mock-reset") !== "1") return false;
  url.searchParams.delete("mock-reset");
  window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
  return true;
}

export function loadPersisted<T>(create: () => T): T {
  if (resetRequested()) localStorage.removeItem(STORAGE_KEY);
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null") as PersistedState<T> | null;
    if (saved?.version === SCHEMA_VERSION) return saved.data;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }
  const data = create();
  savePersisted(data);
  return data;
}

export function savePersisted<T>(data: T) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: SCHEMA_VERSION, data }));
}
